var exports = {
  "i": "xaee3c4fa--a28930--wrapper",
};

module.exports = exports;
